import React, { useEffect } from "react";
import { Form, Input, InputNumber, Switch, Typography } from "antd";
import ArrayImage from "@src/packages/pro-component/schema/ArrayImage";
import Image from "@src/packages/pro-component/schema/Image";
import RichText from "@src/components/Widget/RichText";
import InputTag from "@src/components/Widget/InputTag";
import { FormSection, SectionContainer } from "../styles";
import SingleModel from "@src/packages/pro-component/schema/SingleModel";
import { FormInstance } from "antd/lib/form";

const { Title } = Typography;

interface BasicInfoSectionProps {
  basicInfoRef: React.RefObject<HTMLDivElement>;
  form: FormInstance; // thêm form
  product?: any; // thêm product data
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ 
  basicInfoRef, 
  form,
  product 
}) => {
  // Thêm useEffect để set form values khi product thay đổi
  useEffect(() => {
    if (product) {
      form.setFieldsValue({
        name: product.name,
        description: product.description,
        images: product.images,
        thumbnail: product.thumbnail,
        categoryId: product.categoryId,
        categoryStoreId: product.categoryStoreId,
        originPrice: product.originPrice,
        price: product.price,
        isActive: product.isActive,
        isApprove: product.isApprove,
        tags: product.tags,
        isHot: product.isHot,
        hotSequence: product.hotSequence,
        sequence: product.sequence,
      });
    }
  }, [product, form]);

  return (
    <SectionContainer ref={basicInfoRef}>
      <FormSection>
        <Title level={4}>Thông tin cơ bản</Title>
        
        <Form.Item
          name="images"
          label="Hình ảnh"
          rules={[{ required: true, message: "Please select images" }]}
        >
          <ArrayImage />
        </Form.Item>

        <Form.Item
          name="thumbnail"
          label="Thumbnail"
          rules={[
            { required: true, message: "Vui lòng chọn hình ảnh" },
          ]}
        >
          <Image width={100} height={100} />
        </Form.Item>

        <Form.Item
          name="name"
          label="Tên sản phẩm"
          rules={[
            { required: true, message: "Vui lòng nhập tên sản phẩm" },
          ]}
        >
          <Input placeholder="Enter product name" />
        </Form.Item>

        <Form.Item
          name="originPrice"
          label="Giá gốc"
          rules={[
            { required: true, message: "Vui lòng nhập giá gốc" },
            {
              type: "number",
              transform: (value) => Number(value),
              message: "Vui lòng nhập số hợp lệ",
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            precision={0}
            placeholder="Nhập giá gốc"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={((value?: string) => Number((value || '').replace(/\$\s?|(,*)/g, ""))) as any}
            prefix="đ"
          />
        </Form.Item>

        <Form.Item
          name="price"
          label="Giá bán"
          rules={[
            { required: true, message: "Vui lòng nhập giá bán" },
            {
              type: "number",
              transform: (value) => Number(value),
              message: "Vui lòng nhập số hợp lệ",
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            precision={0}
            placeholder="Nhập giá bán"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={((value?: string) => Number((value || '').replace(/\$\s?|(,*)/g, ""))) as any}
            prefix="đ"
          />
        </Form.Item>

        <Form.Item
          name="categoryId"
          label="Danh mục"
          rules={[
            { required: true, message: "Vui lòng chọn danh mục" },
          ]}
        >
          <SingleModel
            schema={{
              pageId: 83,
              api: "get_categories",
              modelSelectMultiple: false,
              modelSelectField: "id$$ID,name$$Tên danh mục",
            }}
            value={undefined as any}
          />
        </Form.Item>

        <Form.Item name="description" label="Mô tả sản phẩm">
          <RichText height={200} width={"100%"} />
        </Form.Item>

        <Form.Item
          name="tags"
          label="Tags"
          tooltip="Nhập tag và nhấn Enter để thêm"
        >
          <InputTag
            placeholder="Nhập tag và nhấn Enter"
            error="Tag"
          />
        </Form.Item>

        <Form.Item name="isHot" label="Sản phẩm nổi bật" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item name="hotSequence" label="Thứ tự sản phẩm nổi bật">
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            precision={0}
            placeholder="Nhập thứ tự"
          />
        </Form.Item>

        <Form.Item name="sequence" label="Thứ tự hiển thị">
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            precision={0}
            placeholder="Nhập thứ tự"
          />
        </Form.Item>
      </FormSection>
    </SectionContainer>
  );
};

export default BasicInfoSection;